const checkIsMockGoogleRecaptcha = (): boolean => {
  return process.env.REACT_APP_MOCK_GOOGLE_RECAPTCHA !== 'true';
};
export { checkIsMockGoogleRecaptcha };
